import { P } from "@/components/ui/Heading";
import { MapPinIcon } from "lucide-react";
import { DropdownOption } from "./interface";

export interface SearchOptionProps {
  option: DropdownOption;
  isSelected: boolean;
  onSelect: (option: DropdownOption) => void;
}

export const SearchOption: React.FC<SearchOptionProps> = ({
  option,
  isSelected,
  onSelect,
}) => {
  return (
    <div
      className={`flex items-center p-2 gap-2 ${
        isSelected ? "bg-gray-200" : "bg-white"
      } hover:bg-gray-200/60 cursor-pointer rounded-lg`}
      onClick={() => onSelect(option)}
    >
      <MapPinIcon className="h-6 w-6 text-primary" />
      <div className="flex flex-col gap-0.5">
        <P className="!mt-0 text-gray-800 font-semibold text-base">
          {option.label}
        </P>
        {option.pathName && (
          <P className="-mt-1 text-gray-600 font-medium text-sm">
            {option.pathName}
          </P>
        )}
      </div>
    </div>
  );
};
